import React from "react"

const VicinityContext = React.createContext()

export default VicinityContext
